
import { SectionCardData } from "@/lib/singularity/section-add-or-swap";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SectionCard extends Vue {
  @Prop()
  value!: SectionCardData;

  @Prop()
  currentSection!: boolean;
}
